import { Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IconComponent } from '@shared/components/ui';

@Component({
  selector: 'app-unauthorized',
  imports: [IconComponent, TranslateModule],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent {
  returnUrl = '/dashboard';
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);

  constructor() {
    this.returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/dashboard';
  }

  navigateToPreviousPage() {
    // Navigate to previous URL if possible
    if (!this.returnUrl && history.state.navigationId > 1) {
      this._router.navigate(['/']); // navigates to default route
    } else {
      this._router.navigateByUrl(this.returnUrl); // navigates to the dashboard
    }
  }
}
